// extracted by mini-css-extract-plugin
export default {"containerText":"Subtitle_containerText__n2bbv"};